import React from 'react'

const SingleSlider = (props) => {
    return (
        <div className='single-slider'>
            <div className="flex-icon">
                <img src={props.icon} alt={props.name} />
                <h4>{props.name}</h4>
            </div>
            <p>{props.data}</p>
            <p><b>{props.beta}</b></p>
        </div>
    )
}

export default SingleSlider